export default "__VITE_ASSET__DkVGKLgV__"